/**
 * @generated SignedSource<<6a250b278694bc07ca29e4d2ca506ce1>>
 * @relayHash cfd6a2d7fd7a641951fd20d668dd8260
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ccebc1f7afbbe2526090ae2a0f8d3879eafa55ec2902cd5b6e80f87c0cf2c40d

import type { ConcreteRequest } from 'relay-runtime';
export type useIsReviewNudgePageEligibleQuery$variables = {
  contentId: string;
};
export type useIsReviewNudgePageEligibleQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly contentProperties: {
        readonly draft: {
          readonly generatedBy: string | null;
        } | null;
      } | null;
      readonly history: {
        readonly ownedBy: {
          readonly accountId?: string | null;
        } | null;
      } | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
  readonly contentContributors: {
    readonly isCurrentUserContributor: boolean | null;
  } | null;
};
export type useIsReviewNudgePageEligibleQuery = {
  response: useIsReviewNudgePageEligibleQuery$data;
  variables: useIsReviewNudgePageEligibleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "contentId"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "status",
    "value": [
      "current",
      "draft"
    ]
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v5 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "DraftContentProperties",
      "kind": "LinkedField",
      "name": "draft",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "generatedBy"
        }
      ]
    }
  ]
},
v6 = {
  "args": [
    (v1/*: any*/)
  ],
  "concreteType": "ContentContributors",
  "kind": "LinkedField",
  "name": "contentContributors",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isCurrentUserContributor"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsReviewNudgePageEligibleQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  }
                ]
              },
              (v5/*: any*/)
            ]
          }
        ]
      },
      (v6/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsReviewNudgePageEligibleQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/)
                    ]
                  }
                ]
              },
              (v5/*: any*/)
            ]
          }
        ]
      },
      (v6/*: any*/)
    ]
  },
  "params": {
    "cacheID": "cfd6a2d7fd7a641951fd20d668dd8260",
    "id": "ccebc1f7afbbe2526090ae2a0f8d3879eafa55ec2902cd5b6e80f87c0cf2c40d",
    "metadata": {},
    "name": "useIsReviewNudgePageEligibleQuery",
    "operationKind": "query",
    "text": "query useIsReviewNudgePageEligibleQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,history{ownedBy{__typename,...on KnownUser{accountId}}},contentProperties{draft{generatedBy}}}},contentContributors(id:$contentId){isCurrentUserContributor}}"
  }
};
})();

(node as any).hash = "bc795c94c5ae03b8c740021353c42c2a";

export default node;
